import { InvocationResponseDto } from "./Invocation"

export default class InvocationResponseResolver {
  private isInvocationResponse(response: unknown): response is InvocationResponseDto {
    return (
      typeof response === "object" &&
      response !== null &&
      "success" in response &&
      typeof (response as any).success === "boolean" &&
      "message" in response &&
      typeof (response as any).message === "string"
    )
  }

  resolve<R>(response: string | null): InvocationResponseDto<R> | null {
    if (response === null) {
      return null
    }

    const parsed = JSON.parse(response)

    if (!this.isInvocationResponse(parsed)) {
      throw new Error("invalid invocation response data")
    }

    if (!parsed.success) {
      throw new Error(`failed response. [message=${parsed.message}]`)
    }

    const invocationResponseDto: InvocationResponseDto = {
      message: parsed.message,
      success: parsed.success,
      data: parsed.data
    }

    return invocationResponseDto
  }
}
